export function getApiBase(): string {
  const base = process.env.REACT_APP_API_URL;
  const isLocalHost = /^(localhost|127\.0\.0\.1|192\.168\.\d+\.\d+)$/.test(window.location.hostname);
  const result = isLocalHost ? '' : (base ? base.replace(/\/$/, '') : '');
  console.log('[getApiBase]', { 
    hostname: window.location.hostname, 
    base, 
    isLocalHost, 
    result 
  });
  return result;
}


